require('./bootstrap');


window.Vue = require('vue').default;

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.eventHub = new Vue();

const queryString = require("query-string");

import ListAddCart from "./components/ListAddCart.vue";
import AddCart from "./components/AddCart.vue";
import Qty from "./components/Qty.vue";
import axios from 'axios';

window.app = new Vue({
    el: "#app",
    data() {
        return {
            payment: 0,
            shipping: 0,
            vat: 0,
            carts: {
                items: [],
                total: 0,
                orgTotal: 0,
                shipping: 0,
                counts: 0,
                serviceFee: 0,
                shipFee: 0,
                shipFree: 0,
                coupon: {
                    sn: null,
                    amount: 0
                },
            },
            selectedProduct: null,
            spec: {
                price: 0,
                offer: 0
            }
        };
    },
    components: { ListAddCart, AddCart, Qty },
    mounted() {
        this.getCart();
        eventHub.$on("addCart", this.addCart);
        eventHub.$on("updateCart", this.getCart);
    },
    methods: {

        choseSpec(id) {
            this.selectedSpec = id;
            axios.get(`/api/getSpec/${id}`).then( r => {
                this.spec = r.data;
            })
            this.getPhotos();
        },

        addCart({ id, qty }) {
            let api = `/carts/add/${id}`;
            // console.log(api);
            let vm = this;
            axios.post(api, { qty: qty, }).then(r => {
                vm.getCart();
                alert(r.data.message);
            });
        },
        getCart() {
            let params = {
                shipping: this.shipping,
                payment: this.payment
                // applyCredit: this.applyCredit
            };

            let url = "/carts.json?" + queryString.stringify(params);

            axios.get(url).then(r => {
                this.carts = r.data;
            });
        },

        deleteCart(id) {
            let api = `/carts/${id}/delete`;
            let vm = this;
            axios.delete(api).then(r => {
                // vm.getCart();
                eventHub.$emit("updateCart");
            });
        },

        setPayment(pay) {
            this.payment = pay;
            this.getCart();
        },

        applyCoupon() {
            if(this.carts.coupon.sn !== null) {
                axios.post(`/cart/applyCoupon/${this.carts.coupon.sn}`).then( r => {
                    alert(r.data.message)
                    eventHub.$emit("updateCart");
                });
            }
        },

        cancelCoupon() {
            axios.post(`/cart/cancelCoupon`).then( r => {
                eventHub.$emit("updateCart");
            });

        }
    }
});

var mySwiper = new Swiper(".home_swiper", {

    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    speed: 2000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    loop: true,
});
